import { StyleSheet, Switch, type SwitchProps } from "react-native";

import { useTheme, useThemedStyles, type ThemeColors } from "~/styles/theme";
import { AppText } from "./AppText";
import { Row } from "./Row";
import { Stack } from "./Stack";

export function SwitchField({
  label,
  description,
  ...props
}: SwitchProps & { label: string; description?: string }) {
  const { colors } = useTheme();
  const { stylesheet } = useThemedStyles(makeStyles);
  return (
    <Row between gap="md" style={stylesheet.field}>
      <Stack gap="xs" style={stylesheet.copy}>
        <AppText weight="semibold">{label}</AppText>
        {description ? <AppText size="xs">{description}</AppText> : null}
      </Stack>
      <Switch
        accessibilityLabel={label}
        trackColor={{ false: colors.border, true: colors.primary }}
        thumbColor={colors.background}
        {...props}
      />
    </Row>
  );
}

const makeStyles = (colors: ThemeColors) => {
  const stylesheet = StyleSheet.create({
    field: { minHeight: 44 },
    copy: { flex: 1 },
  });
  return { stylesheet };
};
